<template>
  <div class="main_title" v-cloak>
    <el-image :src="requireImage(image)"></el-image>
    <div class="yinying"></div>
    <div class="item">
      <div>{{ $store.state.headerTitle }}</div>
      <div class="item-text">{{ $store.state.headerText }}</div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "HelloWorld",
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      image: "toutu(1).png",
    };
  },
  created() {},
  methods: {
    // 动态图片
    requireImage(url) {
      return require(`../../assets/images/${url}`);
    },
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
[v-cloak] {
  display: none;
}

.main_title {
  width: 100%;
  height: auto;
  height: 144px;
  display: flex;
  position: relative;
  margin-top: -1px;

  .el-image {
    width: 100%;
    height: 144px;
  }

  .yinying {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    // background: #000000;
    // opacity: 0.1;
  }

  .item {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 33px;
    font-weight: 400;
    // color: #FFFFFF;
    color: rgba(#ffffff, 0.8);

    .item-text {
      font-size: 21px;
      font-weight: 400;
      color: rgba(#ffffff, 0.8);
      padding-top: 8px;
    }
  }
}

@media screen and (max-width: 1680px) {
  .main_title {
    width: 100%;
    height: auto;
    height: 126px;
    display: flex;
    position: relative;
    margin-top: -1px;

    .el-image {
      width: 100%;
      height: 126px;
    }

    .item {
      font-size: 33px;

      .item-text {
        font-size: 21px;
        padding-top: 8px;
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .main_title {
    width: 100%;
    height: auto;
    height: 102px;
    display: flex;
    position: relative;
    margin-top: -1px;

    .el-image {
      width: 100%;
      height: 102px;
    }

    .item {
      font-size: 27px;

      .item-text {
        font-size: 17px;
        padding-top: 5px;
      }
    }
  }
}

@media screen and (max-width: 1280px) {
  .main_title {
    width: 100%;
    height: auto;
    height: 96px;
    display: flex;
    position: relative;
    margin-top: -1px;

    .el-image {
      width: 100%;
      height: 96px;
    }

    .item {
      font-size: 25px;

      .item-text {
        font-size: 16px;
        padding-top: 5px;
      }
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/header/title.vue